import { Component, HostListener, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../services/authentication.service';
import { HttpService } from '../../../services/http.service';
import { config } from '../../../config';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  user: any;
  tamplate_setting: any;
  notifications: any[] = [];
  unreadCount = 0;
  isNotifLoading = false;
  isNotifOpen = false;
  private refreshTimer: any = null;
  private notifEventSource: EventSource | null = null;
  
  constructor(
    private authService: AuthenticationService,
    private httpService: HttpService,
    private router: Router,
    public renderer: Renderer2
  ) {
    this.user = JSON.parse(sessionStorage.getItem('user'));
  }

  ngOnInit() {
    this.tamplate_setting = JSON.parse(localStorage.getItem('tamplate_setting')) || {};
    this.isCollapseMenu();

    if (this.isSuperAdmin()) {
      this.loadNotifications();
      this.refreshTimer = setInterval(() => this.loadNotifications(), 45000);
      this.setupNotificationStream();
    }
  }

  ngOnDestroy() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
      this.refreshTimer = null;
    }

    if (this.notifEventSource) {
      this.notifEventSource.close();
      this.notifEventSource = null;
    }
  }

  isSuperAdmin(): boolean {
    return !!(this.user && Number(this.user.user_role) === 0);
  }

  collapseMenu() {
    this.tamplate_setting.sidebar_collapse = this.tamplate_setting.sidebar_collapse ? false : true;
    if(window.innerWidth > 1024) {
      localStorage.setItem('tamplate_setting', JSON.stringify(this.tamplate_setting));
      this.isCollapseMenu();
    } else {
        document.querySelector("body").classList.remove('sidebar-collapse');
        document.querySelector("body").classList.toggle('sidebar-open');
    }
  }
  isCollapseMenu() {
    this.tamplate_setting.sidebar_collapse ? this.renderer.addClass(document.body, 'sidebar-collapse') : this.renderer.removeClass(document.body, 'sidebar-collapse')
  }

  toggleNotificationDropdown(event: Event) {
    event.preventDefault();
    event.stopPropagation();

    this.isNotifOpen = !this.isNotifOpen;
    if (this.isNotifOpen) {
      this.loadNotifications(true);
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    if (!this.isNotifOpen) {
      return;
    }

    const target = event && event.target ? event.target as HTMLElement : null;
    if (!target) {
      return;
    }

    if (!target.closest('.notifications-wrap')) {
      this.closeNotificationDropdown();
    }
  }

  @HostListener('document:keydown.escape')
  onEscape() {
    this.closeNotificationDropdown();
  }

  closeNotificationDropdown() {
    this.isNotifOpen = false;
  }

  setupNotificationStream() {
    const token = sessionStorage.getItem('token');
    if (!token || !this.isSuperAdmin() || typeof EventSource === 'undefined') {
      return;
    }

    const streamUrl = `${config.API_URL}admin-stream/admin-activities?token=${encodeURIComponent(token)}`;

    if (this.notifEventSource) {
      this.notifEventSource.close();
      this.notifEventSource = null;
    }

    this.notifEventSource = new EventSource(streamUrl);

    const handlePayload = (event: MessageEvent) => {
      if (!event || !event.data) {
        return;
      }

      try {
        const payload = JSON.parse(event.data);
        if (!payload || payload.status === false) {
          return;
        }

        this.unreadCount = Number(payload.unreadCount || 0);
        this.notifications = Array.isArray(payload.data) ? payload.data : [];
      } catch (error) {
        // Ignore malformed stream payloads.
      }
    };

    this.notifEventSource.addEventListener('init', handlePayload as EventListener);
    this.notifEventSource.addEventListener('update', handlePayload as EventListener);
    this.notifEventSource.addEventListener('error', () => {
      // EventSource will auto-reconnect; keep polling fallback as backup.
    });
  }

  loadNotifications(autoMarkVisible: boolean = false) {
    if (!this.isSuperAdmin()) {
      return;
    }

    this.isNotifLoading = true;
    this.httpService.getAdminActivityUnread(8).subscribe(
      (res: any) => {
        this.isNotifLoading = false;
        this.unreadCount = Number((res && res.unreadCount) || 0);
        this.notifications = res && Array.isArray(res.data) ? res.data : [];

        if (autoMarkVisible && this.isNotifOpen) {
          this.autoMarkVisibleNotifications();
        }
      },
      () => {
        this.isNotifLoading = false;
        this.notifications = [];
        this.unreadCount = 0;
      }
    );
  }

  autoMarkVisibleNotifications() {
    if (!this.isNotifOpen || !this.notifications || !this.notifications.length) {
      return;
    }

    const visibleIds = this.notifications
      .slice(0, 8)
      .map((item) => item && item._id ? item._id : null)
      .filter((id) => !!id);

    if (!visibleIds.length) {
      return;
    }

    this.httpService.markAdminActivityRead(visibleIds).subscribe(
      () => {
        this.loadNotifications();
      },
      () => {}
    );
  }

  openActivity(item: any) {
    if (!item || !item._id) {
      this.goToAllActivities();
      return;
    }

    this.httpService.markAdminActivityRead([item._id]).subscribe(
      () => {
        this.loadNotifications();
      },
      () => {}
    );

    this.closeNotificationDropdown();
    this.router.navigate(['/admin/system-user-activities']);
  }

  markAllRead(event: Event) {
    event.preventDefault();
    event.stopPropagation();

    this.httpService.markAllAdminActivityRead().subscribe(
      () => {
        this.loadNotifications();
      },
      () => {}
    );
  }

  goToAllActivities(event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    this.closeNotificationDropdown();
    this.router.navigate(['/admin/system-user-activities']);
  }

  displayActor(item: any): string {
    if (item && item.actor_name) {
      return item.actor_name;
    }

    const actor = item && item.actor_user_id ? item.actor_user_id : null;
    if (actor) {
      const fullName = `${actor.first_name || ''} ${actor.last_name || ''}`.trim();
      if (fullName) {
        return fullName;
      }
      if (actor.email) {
        return actor.email;
      }
    }

    return 'System';
  }

  displayAgo(item: any): string {
    if (item && item.ago) {
      return item.ago;
    }

    const created = item && item.created_date ? new Date(item.created_date).getTime() : Date.now();
    const diff = Math.max(Date.now() - created, 0);
    const min = Math.floor(diff / 60000);
    const hr = Math.floor(min / 60);
    const day = Math.floor(hr / 24);

    if (day > 0) {
      return `${day}d ago`;
    }
    if (hr > 0) {
      return `${hr}h ago`;
    }
    if (min > 0) {
      return `${min}m ago`;
    }
    return 'just now';
  }

  platformLabel(item: any): string {
    const platform = String((item && item.platform) || 'unknown');
    if (platform === 'manager-app') return 'Manager App';
    if (platform === 'printer-app') return 'Printer App';
    if (platform === 'admin') return 'Admin';
    if (platform === 'epos') return 'EPOS';
    if (platform === 'website') return 'Website';
    if (platform === 'api') return 'API';
    return 'System';
  }

  severityLabel(item: any): string {
    const severity = String((item && item.severity) || 'info').toLowerCase();
    if (severity === 'critical') return 'Critical';
    if (severity === 'warn') return 'Warn';
    return 'Info';
  }

  severityClass(item: any): string {
    const severity = String((item && item.severity) || 'info').toLowerCase();
    if (severity === 'critical') return 'sev-critical';
    if (severity === 'warn') return 'sev-warn';
    return 'sev-info';
  }

  logout() {
    this.closeNotificationDropdown();
    this.authService.logout();
  }


}
